document.addEventListener("DOMContentLoaded", function () {
const swiper = new Swiper(".mob-log-swiper", {
      spaceBetween: 0,
  centeredSlides: true,
  speed: 2000,
  autoplay: {
    delay: 1,
  },
  loop: true,
  slidesPerView:'auto',
  allowTouchMove: false,
  disableOnInteraction: true,

  breakpoints: {
    0: { spaceBetween: 50 },
    768: { spaceBetween: 40 },
    1200: { spaceBetween: 90 },
  },
});





  document.querySelectorAll('.faq-ques').forEach(item => {
    item.addEventListener('click', function () {

      this.classList.toggle('active');

      const answer = this.querySelector('.faq-ans');
      if (answer) {
        answer.classList.toggle('active');
      }

    });
  });

  
});